import React from "react";
import { Box, Typography, Button } from "@mui/material";

const BottomBar = ({ leftContent, rightContent, onLeftButtonClick, onRightButtonClick }) => {
    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                backgroundColor: "#f5f5f5",
                borderTop: "1px solid #ddd",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 20px",
                zIndex: 1000,
            }}
        >
            <Box>
                {onLeftButtonClick && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onLeftButtonClick}
                        sx={{ margin: "0 auto" }}
                    >
                        {leftContent}
                    </Button>
                )}
            </Box>
            {onRightButtonClick && (
                <Box sx={{ position: "absolute", right: "20px" }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onRightButtonClick}
                    >
                        {rightContent}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default BottomBar;
